import { getDefaultAdminPath } from './adminNavConfig';
import { hasAnyPermission } from './permissions';
import { PERMISSIONS } from './permissionConstants';

export const normalizeRoleName = (roleName) =>
  (roleName || '').toLowerCase().trim().replaceAll(/\s+/g, '_');

export const getRoleName = (role) => {
  if (!role) return '';
  return role.name || role.role_name || role.roleName || '';
};

export const normalizeRole = (role) => {
  if (!role) return null;
  const name = getRoleName(role);
  return { ...role, name };
};

export const getRedirectPathByRole = (roleName, userPermissions = []) => {
  const name = normalizeRoleName(roleName);

  if (name === 'affiliate') {
    return '/dashboard';
  }

  if (userPermissions?.length) {
    if (name === 'sales') {
      const estimatePerms = [
        PERMISSIONS.ESTIMATE_REQUEST,
        PERMISSIONS.ESTIMATE_REQUEST_VIEW,
        PERMISSIONS.ESTIMATE_REQUEST_ADD,
      ];
      if (hasAnyPermission(userPermissions, estimatePerms)) {
        return '/admin/estimate-requests';
      }
    }
    return getDefaultAdminPath(userPermissions);
  }

  switch (name) {
    case 'admin':
    case 'super_admin':
    case 'affiliate_manager':
      return '/admin/dashboard';
    case 'sales':
      return '/admin/estimate-requests';
    default:
      return '/admin/dashboard';
  }
};

export const readAuthFromStorage = () => {
  try {
    const savedAuth = localStorage.getItem('authState');
    if (savedAuth) {
      return JSON.parse(savedAuth);
    }
  } catch (error) {
    // Return null if reading auth state fails
  }
  return null;
};

/** Login page to use after logout, based on role */
export const getLoginPathByRole = (role) => {
  const name = normalizeRoleName(getRoleName(role));

  switch (name) {
    case 'super_admin':
      return '/super-admin/login';
    case 'affiliate_manager':
      return '/user/login';
    case 'affiliate':
      return '/login';
    default:
      return '/admin/login';
  }
};

export const isRoleAllowed = (role, allowedRoles) => {
  if (!allowedRoles?.length) return true;

  const roleName = normalizeRoleName(getRoleName(role));
  return allowedRoles.some(
    (allowed) => normalizeRoleName(allowed) === roleName
  );
};
